/**
 * Scene component extracted from WordGameScene
 */

class WordGameSceneComponent extends ScriptComponent {
    onCreate() {
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.gameSceneComponent = ComponentMap.get(this.node, GameSceneComponent);
    }

    onSceneLoaded() {
        const game = Game.currentGame;

        if (cleverapps.config.subtype === "stacks") {
            LetterBlockView.bgImage = this.sceneComponent.styling.bgImage;
            LetterBlockView.bgImageHighlighted = this.sceneComponent.styling.bgImageHighlighted;
            LetterBlockView.bgImageHint = this.sceneComponent.styling.bgImageHint;
            LetterBlockView.hintColor = this.sceneComponent.styling.hintColor;
            cleverapps.BoardView.foundWordBg = this.sceneComponent.styling.foundWordBg;
        }

        const keypadView = this.keypadView = new KeypadView(game.keypad);
        this.node.addChild(keypadView);

        const boardView = this.boardView = new cleverapps.BoardView(game.board);
        this.node.addChild(boardView);

        if (!cleverapps.gameModes.noCurrent) {
            const currentView = this.currentView = new cleverapps.CurrentView(game.current);
            this.node.addChild(currentView);
        }

        if (game.hintBooster.isAvailable()) {
            this.createHintButton();
        }

        if (game.openLetterBooster && game.openLetterBooster.isAvailable()) {
            this.createOpenLetterButton();
        }

        const rewardForExtra = Game.currentGame.level.isRegular() || !Game.currentGame.level.isRegular();
        levels.cookieJar.setShouldRewardInCurrentLevel(rewardForExtra);

        if (rewardForExtra && !cleverapps.gameModes.noCookieJar) {
            new CookieJarView(game.extra, this.node);
        }
    }

    onReady() {
        const game = Game.currentGame;

        if (game.bonusTimer) {
            const bonusLevelView = this.bonusLevelView = new BonusLevelView(game.bonusLevelCounter, game.bonusTimer.getTimeLeft());
            this.node.addChild(bonusLevelView, -1);
        }
    }

    hasShuffleButton() {
        if (cleverapps.config.subtype !== "stacks") {
            return false;
        }

        return cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_SHUFFLE).isAvailable();
    }

    buildShuffleButton() {
        this.shuffleButtonView = new ShuffleButtonBooster(cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_SHUFFLE));
        return this.shuffleButtonView;
    }

    getShuffleButtonControlName() {
        return cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_SHUFFLE).getControlId();
    }

    hasKingsCupMarks() {
        return !!Game.currentGame.kingsCupMission;
    }

    buildKingsCupMarksView() {
        return new KingsCupMarksView();
    }

    getKingsCupMarksHiddenByDefault() {
        return cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
    }

    hasLightningRushMarks() {
        return !!Game.currentGame.lightingRushMission;
    }

    buildLightningRushMarksView() {
        return new LightningRushMarksView();
    }

    getLightningRushHiddenByDefault() {
        return cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
    }

    onAfterResize() {
        const currentPosition = this.currentView && this.currentView.getPosition();
        const centerPoint = currentPosition && this.node.convertToWorldSpace(cc.p(currentPosition.x, currentPosition.y + 100 * resolutionScale));

        let availableRect = cleverapps.UI.calcBoundaries(this.getOverlappingNodes(), {
            centerPoint
        });
        availableRect = cc.rectSubPadding(availableRect, cc.padding(this.styles.board.padding));

        availableRect = cc.convertRectToNodeSpace(this.node, availableRect);

        this.boardView.updateGrid(availableRect);
        this.boardView.updateBackground();
    }

    getOverlappingNodes() {
        let nodes = [this.keypadView, ComponentUtils.findComponentByName(this.node, "UpMenuController").node, this.currentView, this.gameSceneComponent.playersView, this.gameSceneComponent.scoreBarView];

        if (this.bonusLevelView) {
            nodes = nodes.concat(this.bonusLevelView.getOverlappingNodes());
        }

        return nodes.filter(Boolean);
    }

    createHintButton() {
        const hintButton = new HintButtonBooster(Game.currentGame.hintBooster);

        this.hintButton = new cc.Node();
        this.hintButton.addChild(hintButton);
        this.node.addChild(this.hintButton, 1);

        ComponentMap.attach(this.hintButton, new HidingComponent({
            control: hintButton.getControlId()
        }));
    }

    createOpenLetterButton() {
        const openLetterButton = new OpenLetterButtonBooster(Game.currentGame.openLetterBooster, this);

        this.openLetterButton = new cc.Node();
        this.openLetterButton.addChild(openLetterButton);
        this.node.addChild(this.openLetterButton, 1);

        ComponentMap.attach(this.openLetterButton, new HidingComponent({
            control: openLetterButton.getControlId()
        }));
    }
}

Prefab.registerComponent("WordGameSceneComponent", WordGameSceneComponent);

GameScene = bundles.main.jsons.wordgamescene_prefab_json;

cleverapps.styles.WordGameScene = {
    minimalPosition: {
        x: { align: "center" },
        y: { align: "center", dy: -45 }
    },
    players: {
        x: { align: "center" },
        y: { align: "top" }
    }
};

if (cleverapps.config.subtype === "stacks") {
    cleverapps.overrideStyles(cleverapps.styles.GameScene.STYLING, {
        bonus: {
            bgImage: bundles.letters.frames.letter_keypad_green_bg_png,
            bgImageHighlighted: bundles.letters.frames.letter_keypad_yellow_bg_png,
            foundWordBg: bundles.game.frames.found_word_bg_bonus_png,
            hintColor: new cc.Color(144, 0, 236, 255),
            themeBg: bundles.game.frames.theme_bg_regular_green
        },

        hard: {
            bgImage: bundles.letters.frames.letter_keypad_orange_bg_png,
            bgImageHighlighted: bundles.letters.frames.letter_keypad_red_bg_png,
            foundWordBg: bundles.game.frames.found_word_bg_hard_png,
            hintColor: new cc.Color(144, 0, 236, 255),
            themeBg: bundles.game.frames.theme_bg_hard
        },

        tricky: {
            bundle: "game_background_vertical",
            skin: "gameBackground",
            music: bundles.game.urls.background_music_tricky,

            bgImage: bundles.letters.frames.letter_keypad_light_blue_bg_png,
            bgImageHighlighted: bundles.letters.frames.letter_keypad_pink_bg_png,
            foundWordBg: bundles.game.frames.found_word_bg_tricky_png,
            hintColor: new cc.Color(244, 234, 138, 255),
            themeBg: bundles.game.frames.theme_bg_tricky
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.GameScene.STYLING.regular[0], {
        bgImage: bundles.letters.frames.letter_keypad_green_bg_png,
        bgImageHighlighted: bundles.letters.frames.letter_keypad_yellow_bg_png,
        foundWordBg: bundles.game.frames.found_word_bg_bonus_png,
        hintColor: new cc.Color(144, 0, 236, 255),
        themeBgColor: new cc.Color(112, 192, 57, 220)
    });

    cleverapps.overrideStyles(cleverapps.styles.GameScene.STYLING.regular[1], {
        bgImage: bundles.letters.frames.letter_keypad_blue_bg_png,
        bgImageHighlighted: bundles.letters.frames.letter_keypad_purple_bg_png,
        foundWordBg: bundles.game.frames.found_word_bg_png,
        hintColor: new cc.Color(250, 28, 115, 255),
        themeBgColor: new cc.Color(36, 151, 224, 220)
    });

    cleverapps.overrideStyles(cleverapps.styles.GameScene.STYLING.regular[2], {
        bgImage: bundles.letters.frames.letter_keypad_blue_bg_png,
        bgImageHighlighted: bundles.letters.frames.letter_keypad_purple_bg_png,
        foundWordBg: bundles.game.frames.found_word_bg_png,
        hintColor: new cc.Color(250, 28, 115, 255),
        themeBgColor: new cc.Color(36, 151, 224, 220)
    });
}